

































































































import { Component, Vue,Inject, Prop,Watch } from 'vue-property-decorator';
import AbpBase from '@/lib/abpbase';
import elementResizeDetector from "element-resize-detector";
import HzLetterEdit from "@/views/jm/jobdo/hz/hzletteredit.vue";
import HzLetterApproval from "@/views/jm/jobdo/hz/hzletterapproval.vue";
import UploadLetterOut from "@/views/jm/jobdo/hz/upload-letter-out.vue";
import HzMailRead from "@/views/jm/jobdo/hz/hzmailread.vue";
@Component({
components:{HzLetterEdit,HzLetterApproval,UploadLetterOut,HzMailRead}
})
export default class HZLetterViews extends AbpBase {
    @Prop({type:String,default:''}) styname:string;
    loadingInstance:boolean=false;
    loading:boolean=false;
    editShow:boolean=false;
    outShow:boolean=false;
    mailShow:boolean=false;
    reftype:string="outfile";
    approvalShow:boolean=false;
    letterid:string="0";
    WinH=window.innerHeight-110;
    rowStyleOption={
            clickHighlight: false,
            hoverHighlight: true,
    };
    get itemList(){
        return [{value:'0',text:'全部'},{value:'1',text:'待核准'},{value:'2',text:'已发送未回函'},{value:'3',text:'收到回函'}]
    }
    get list(){
        var data=this.$store.state.hzletter.list;
        var statusid=this.styname;   
        if(Number(statusid)==0){
            return data;
        }
        else{
            return data.filter(n=>n.statusId===statusid);
        } 
    }
    get jobauth(){
       let d= this.$store.state.jobdo.roles;
       if(d.length>0){
          return d[0].checked=='1'?true:false;
       }
       return false;
    }
    async itemChange(){

    }
    async RowClick(row:any) {  
        var id=row.id;
        if(Number(id)>0){
            this.letterid=id;
            this.editShow=true;
        }
    }
    async approvalallsend(){
        this.approvalShow=true;
    }
    async uploadfile(type:any){
        this.reftype=type;
        this.outShow=true;
    }
    async DownFile(row:any){
        this.loading=true;
        let currid=this.$store.state.jobdo.currjob;
        await this.$store.dispatch({
            type:'hzletter/downLoadFile',
            data:{id:row.id,projectid:currid,filename:row.fileName}
        });
        this.loading=false;
    }
    async DownOutFile(row:any){
        this.loading=true;
        let currid=this.$store.state.jobdo.currjob;
        await this.$store.dispatch({
            type:'hzletter/downOutFile',
            data:{id:row.id,projectid:currid,filename:row.outName}
        });
        this.loading=false;
    }
    async DownInFile(row:any){
        this.loading=true;
        let currid=this.$store.state.jobdo.currjob;
        await this.$store.dispatch({
            type:'hzletter/downInFile',
            data:{id:row.id,value:row.letterReplyId,projectid:currid,filename:row.letterReplyFile}
        });
        this.loading=false;
    }
    async getdata(){
        this.loadingInstance=true;
        let currid=this.$store.state.jobdo.currjob;
        await this.$store.dispatch({
            type:'hzletter/get',
            data:{Id:currid}
        }); 
        this.loadingInstance=false;
    }
    async refresh(){
        await this.getdata();
    }
    async readmail(){
        this.mailShow=true;
    }
    async created(){
      await this.getdata();
    }
    // @Watch('styname')
    //     activeChange(styid:any){
    //       this.styname=styid;
    //     };
    mounted(){
        const that = this;
        var erd = elementResizeDetector();
        erd.listenTo(document.getElementsByClassName("el-table"), (element) => {   
        that.$nextTick(() => { 
            that.WinH=window.innerHeight-110;
            });
        });  
    }
}
